<div class="filter-container row no-gutters">
  <label
    class="filter-label px-2"
    *ngIf="isAdmin"
    [ngClass]="{ desktop: mobile == false }"
  >
    Cities

    <div class="chip filter-menu" mdbDropdown>
      <div mdbDropdownToggle class="row no-gutters align-items-center">
        <div class="filter-value">
          {{ cityFilterValue }}
        </div>
        <div class="spacer"></div>
        <mat-icon class="filter-icon">expand_more</mat-icon>
      </div>

      <div class="dropdown-menu dropdown-primary">
        <a class="dropdown-item body3" (click)="setCityFilter(null)">All</a>
        <div class="divider dropdown-divider"></div>
        <div
          class="dropdown-item body3"
          *ngFor="let city of cities"
          (click)="setCityFilter(city)"
        >
          {{ city.name + ", " + city.state }}
        </div>
      </div>
    </div>
  </label>

  <label
    class="filter-label px-2"
    *ngIf="isAdmin"
    [ngClass]="{ desktop: mobile == false }"
  >
    Venues

    <div class="chip filter-menu" mdbDropdown>
      <div mdbDropdownToggle class="row no-gutters align-items-center">
        <div class="filter-value">
          {{ currentVenue == null ? "All" : currentVenue.name }}
        </div>
        <div class="spacer"></div>
        <mat-icon class="filter-icon">expand_more</mat-icon>
      </div>

      <div class="dropdown-menu dropdown-primary">
        <a class="dropdown-item body3" (click)="setVenueFilter(null)">All</a>
        <div class="divider dropdown-divider"></div>
        <a
          class="dropdown-item body3"
          *ngFor="let venue of venues"
          (click)="setVenueFilter(venue)"
          >{{ venue.name }}</a
        >
      </div>
    </div>
  </label>

  <label class="filter-label px-2" [ngClass]="{ desktop: mobile == false }">
    Timeframe

    <div class="chip filter-menu" mdbDropdown>
      <div mdbDropdownToggle class="row no-gutters align-items-center">
        <div class="filter-value">
          {{ currentTimeframe.label }}
        </div>
        <div class="spacer"></div>
        <mat-icon class="filter-icon">expand_more</mat-icon>
      </div>
      <div class="dropdown-menu dropdown-primary">
        <a
          class="dropdown-item body3"
          *ngFor="let tf of timeframes"
          (click)="changeTimeframe(tf)"
          >{{ tf.label }}</a
        >
      </div>
    </div>
  </label>

  <label class="filter-label px-2" [ngClass]="{ desktop: mobile == false }"
    >Pass Type
    <div class="chip filter-menu" mdbDropdown>
      <div mdbDropdownToggle class="row no-gutters align-items-center">
        <div class="filter-value">
          {{ productMask(currentProductType) }}
        </div>
        <div class="spacer"></div>
        <mat-icon class="filter-icon">expand_more</mat-icon>
      </div>
      <div class="dropdown-menu dropdown-primary">
        <a class="dropdown-item body3" (click)="setProductTypeFilter(null)"
          >All</a
        >
        <div class="divider dropdown-divider"></div>
        <a
          class="dropdown-item body3"
          *ngFor="let type of productTypes"
          (click)="setProductTypeFilter(type)"
          >{{ productMask(type) }}</a
        >
      </div>
    </div>
  </label>

  <ng-container *ngIf="showRedeemFilter">
    <label class="filter-label px-2" [ngClass]="{ desktop: mobile == false }"
      >Redeemed
      <div
        class=" chip filter-chip"
        [ngClass]="{ active: showRedeemed }"
        (click)="setRedeemedFilter()"
      >
        <div class="row no-gutters justify-content-between align-items-center">
          <div class="filter-value">
            Yes
          </div>
          <mat-icon *ngIf="showRedeemed">close</mat-icon>
          <mat-icon *ngIf="!showRedeemed">add</mat-icon>
        </div>
      </div>

      <div
        class=" chip filter-chip"
        [ngClass]="{ active: showOutstanding }"
        (click)="setOutstandingFilter()"
      >
        <div class="row no-gutters justify-content-between align-items-center">
          <div class="filter-value">
            No
          </div>
          <mat-icon *ngIf="showOutstanding">close</mat-icon>
          <mat-icon *ngIf="!showOutstanding">add</mat-icon>
        </div>
      </div>
    </label>
  </ng-container>
</div>
